"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _DarkCheckbox = require("./DarkCheckbox.style");

var _Icon = _interopRequireDefault(require("../Icon"));

var _class;

var DarkCheckbox = (0, _emotionTheming.withTheme)(_class =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DarkCheckbox, _PureComponent);

  function DarkCheckbox() {
    (0, _classCallCheck2.default)(this, DarkCheckbox);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DarkCheckbox).apply(this, arguments));
  }

  (0, _createClass2.default)(DarkCheckbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          theme = _this$props.theme,
          label = _this$props.label,
          style = _this$props.style,
          className = _this$props.className,
          disabled = _this$props.disabled,
          strokeWidth = _this$props.strokeWidth,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["onClick", "theme", "label", "style", "className", "disabled", "strokeWidth"]);
      return _react.default.createElement("label", {
        style: style,
        className: (0, _classnames.default)(className, (0, _DarkCheckbox.labelStylesDark)(theme, disabled)),
        onClick: onClick
      }, _react.default.createElement("input", (0, _extends2.default)({
        type: "checkbox"
      }, other, {
        disabled: disabled
      })), _react.default.createElement("div", {
        className: (0, _classnames.default)('uncheckedbox', (0, _DarkCheckbox.checkboxStylesDark)(theme, disabled))
      }, _react.default.createElement(_Icon.default, {
        type: "uncheckedbox",
        style: {
          strokeWidth: strokeWidth
        }
      })), _react.default.createElement("div", {
        className: (0, _classnames.default)('checkedbox', (0, _DarkCheckbox.checkboxStylesDark)(theme, disabled))
      }, _react.default.createElement(_Icon.default, {
        type: "checkedbox",
        style: {
          strokeWidth: strokeWidth
        }
      })), _react.default.createElement("span", null, label));
    }
  }]);
  return DarkCheckbox;
}(_react.PureComponent)) || _class;

DarkCheckbox.propTypes = {
  label: _propTypes.default.string,
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  strokeWidth: _propTypes.default.number
};
DarkCheckbox.defaultProps = {
  label: '',
  style: {},
  className: '',
  disabled: false,
  strokeWidth: 0.2
};
var _default = DarkCheckbox;
exports.default = _default;